import { FieldValues } from 'react-hook-form';
import { FieldProps } from '../../../../generic/FieldProps';
import { GenericInputField } from '../../../../generic/GenericInputField';
import { DateOfDeathInput } from '../../../BasePersonInputs/DateOfDeath/DateOfDeathInput';

export function DateOfDeathField<TValues extends FieldValues>(
  props: FieldProps<TValues>
) {
  return (
    <GenericInputField<TValues>
      {...props}
      Input={DateOfDeathInput}
      label='Auflösungsdatum'
    />
  );
}
